import React from "react";

import "./TableRow.css";

export default function TableRow(props){
    return (
        <tr className = "admin-panel-table-row">{props.children}</tr>
    );

}